import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';

import { Skeleton } from '@/components/ui/skeleton';

export default function GroupCardSkeleton(GroupCardSkeletonProps: ComponentProps<'div'>) {
  const { className, ...props } = GroupCardSkeletonProps;
  return (
    <div className={cn('border-border-primary bg-background flex h-fit flex-col rounded-2xl border', className)} {...props}>
      <div className={'border-border-primary flex items-center gap-3 border-b p-4'}>
        <Skeleton className={'h-9 w-9 rounded-sm'} />
        <Skeleton className={'h-4 w-[12ch] rounded-sm text-lg'} />
      </div>
      <div className={'flex h-full flex-col gap-3 p-4'}>
        <div className={'flex flex-col gap-2'}>
          <Skeleton className={'h-4 w-[11ch] rounded-sm text-xs'} />
          <div className={'flex flex-wrap gap-1'}>
            <Skeleton className={'h-6 w-14 rounded-sm'} />
            <Skeleton className={'h-6 w-13 rounded-sm'} />
            <Skeleton className={'h-6 w-13 rounded-sm'} />
          </div>
        </div>
        <div className={'flex flex-col gap-2'}>
          <Skeleton className={'h-4 w-[11ch] rounded-sm text-xs'} />
          <div className={'flex flex-wrap gap-1'}>
            <Skeleton className={'h-6 w-14 rounded-sm'} />
            <Skeleton className={'h-6 w-13 rounded-sm'} />
            <Skeleton className={'h-6 w-13 rounded-sm'} />
          </div>
        </div>
        <div className={'flex items-center justify-between gap-2'}>
          <div className={'flex'}></div>
          <Skeleton className={'h-10 w-24 rounded-md'} />
        </div>
      </div>
    </div>
  );
}
